let HOST = "https://node.nunamoving.com:8080/api/v1/";
export const BASE_URL = "https://node.nunamoving.com:8080/api/v1/";
// export const BASE_URL = "https://node.mystorybank.info:4000/api/v1/";
export const BASE_URL_IMAGE = "https://node.nunamoving.com:8080/images/";
export const BASE_URL_VIDEO = "https://node.nunamoving.com:8080/videos/";

export default HOST;
